import axios from "axios";

const instance = axios.create({
  timeout: 10000,
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  }
});

export default {
  lang(data) {
    return axios.post("Server/lang", data);
  },
  // getVisitorRecord() {
  //     return axios.post("Visitor/getVisitorRecord");
  // },
  access() {
    return axios.post("wechat/access");
  },
  record() {
    return axios.post("wechat/record");
  },
  region() {
    return axios.post("wechat/region");
  },
  approval(id, status, cause) {
    return axios.post("wechat/approval", {
      id: id,
      status: status,
      cause: cause
    });
  },
  num(id, num) {
    return axios.post("wechat/num", {
      id: id,
      num: num
    });
  },
  invite(data) {
    // 被访人邀请客户
    return axios.post("Staff/invite", data);
  },
  interview(data) {
    // HR邀请面试者
    return axios.post("Staff/interview", data);
  },
  ticket(data) {
    return axios.post("wechat/ticket", data);
  },
  getRecord(data) {
    return axios.post("wechat/getRecord", data);
  },
  signIn(data) {
    return axios.post("admin/signIn", data);
  },
  staff() {
    return axios.post("admin/staff");
  },

  getRegion() {
    return axios.post("admin/region");
  },
  getInvite(data) {
    return axios.post("admin/invite", data);
  },
  getArrive(data) {
    return axios.post("admin/arrive", data);
  },
  staffData() {
    return axios.post("server/sync");
  },
  menuData() {
    return axios.post("server/menu");
  },
  changePassword(data) {
    return axios.post("admin/changePassword", data);
  },
  searchStaff(data) {
    return axios.post("admin/searchStaff", data);
  },
  getSystem() {
    return axios.post("admin/getSystem");
  },
  changeSystem(data) {
    return axios.post("admin/changeSystem", data);
  },
  deleteRegion(data) {
    return axios.post("admin/deleteRegion", data);
  },
  getPort() {
    return axios.post("admin/getPort");
  },
  createRegion(data) {
    return axios.post("admin/createRegion", data);
  },
  updateRegion(data) {
    return axios.post("admin/updateRegion", data);
  },
  searchInvite(data) {
    return axios.post("admin/searchInvite", data);
  },

  createStaff(data) {
    //单个添加被访人信息
    return axios.post("admin/createStaff", data);
  },
  deleteStaff(data) {
    //单个删除被访人信息
    return axios.post("admin/deleteStaff", data);
  },
  updateStaff(data) {
    //单个删除修改被访人信息
    return axios.post("admin/updateStaff", data);
  },
  getDepartment(data) {
    // 获取部门信息
    return axios.post("admin/getDepartment", data);
  },
  createDepartment(data) {
    //添加部门信息
    return axios.post("admin/createDepartment", data);
  },
  deleteDepartment(data) {
    //删除部门信息
    return axios.post("admin/deleteDepartment", data);
  },
  updateDepartment(data) {
    //删除修改部门信息
    return axios.post("admin/updateDepartment", data);
  },
  getReasons(data) {
    // 获取来访事由
    return axios.post("Server/getReasons", data);
  },
  getArea() {
    // 获取拜访厂区
    return axios.post("Server/getArea");
  },
  getArea2(data) {
    // 获取拜访区域
    return axios.post("Server/getArea2", data);
  },
  getVisitorType() {
    // 获取来访类型
    return axios.post("Server/getVisitorType");
  },
  createReasons(data) {
    //添加来访事由
    return axios.post("admin/createReasons", data);
  },
  deleteReasons(data) {
    //删除来访事由
    return axios.post("admin/deleteReasons", data);
  },
  updateReasons(data) {
    //删除修改来访事由
    return axios.post("admin/updateReasons", data);
  },
  searchReserve(data) {
    //查找访客预约记录
    return axios.post("admin/searchReserve", data);
  },
  deleteRecord(data) {
    //删除预约记录
    return axios.post("admin/deleteRecord", data);
  },

  vpersonal(data) {
    //提交访客信息
    return axios.post("Visitor/vpersonal", data);
  },
  getVisitorInfo() {
    //获取访客信息
    return axios.post("Visitor/getVisitorInfo");
  },
  getStaffName(data) {
    //获取被访人姓名
    return axios.post("Visitor/getStaffName", data);
  },
  getStaffLst(data) {
    //获取被访人姓名
    return axios.post("Visitor/getStaffLst", data);
  },
  // getReasons(data) {//获取来访事由
  //     return axios.post('wechat/getReasons', data);
  // },
  vreserve(data) {
    //发起预约
    return axios.post("Visitor/reserve", data);
  },
  vreserveCar(data) {
    //发起预约
    return axios.post("Visitor/reserveCar", data);
  },
  vreserve2(data) {
    //访客通过员工发起的链接填写预约信息
    return axios.post("Staff/reserve2", data);
  },
  getTicket(data) {
    //
    return axios.post("WechatServer/getTicket", data);
  },
  getSVecord(data) {
    //访客获取模板消息的记录
    return axios.post("wechat/getSVecord", data);
  },

  getStaffInfo(data) {
    //获取被访人信息
    return axios.post("Staff/getStaffInfo", data);
  },
  spersonal(data) {
    //被访人员绑定信息
    return axios.post("Staff/spersonal", data);
  },
  saveSpersonal(data) {
    //
    return axios.post("Staff/saveSpersonal", data);
  },
  disSpersonal(data) {
    //被访人员解除绑定
    return axios.post("Staff/disSpersonal", data);
  },
  getCode(data) {
    //被访人员获取短信验证码
    return axios.post("Server/getCode", data);
  },
  staffRefuse(data) {
    //被访人员拒绝来访
    return axios.post("Staff/staffRefuse", data);
  },
  staffAgree(data) {
    //被访人员同意来访
    return axios.post("Staff/staffAgree", data);
  },
  leaderRefuse(data) {
    //领导拒绝来访
    return axios.post("Staff/leaderRefuse", data);
  },
  leaderAgree(data) {
    //领导同意来访
    return axios.post("Staff/leaderAgree", data);
  },
  getSRecord(data) {
    //被访人员获取模板消息的记录
    return axios.post("Staff/getSRecord", data);
  },
  getLRecord(data) {
    //部门领导获取模板消息的记录
    return axios.post("wechat/getLRecord", data);
  },
  getVRecord(data) {
    //访客获取模板消息的记录
    return axios.post("wechat/getVRecord", data);
  },
  getCRecord(data) {
    //抄送人获取模板消息的记录
    return axios.post("wechat/getCRecord", data);
  },
  getStaffRecord(data) {
    //获取员工的预约、邀请记录
    return axios.post("Staff/getStaffRecord", data);
  },
  getVisitorRecord(data) {
    //获取访客预约记录
    return axios.post("Visitor/getVisitorRecord", data);
  },
  getVisitorRecordCar(data) {
    //获取访客预约记录
    return axios.post("Visitor/getVisitorRecordCar", data);
  },
  getSRecordCar(data) {
    //
    return axios.post("Visitor/getSRecordCar", data);
  },
  // getSRecord(data) {
  //   //被访人员获取模板消息的记录
  //   return axios.post("Staff/getSRecord", data);
  // },

  searchLeaderLst(data) {
    // 查找审批人
    return axios.post("wechat/searchLeaderLst", data);
  },

  // 放行条
  getItemType(data) {
    // 获取物品类型
    return axios.post("Release/getItemType", data);
  },
  getReleaseReason(data) {
    // 获取放行原因
    return axios.post("Release/getReleaseReason", data);
  },
  createRelease(data) {
    // 发起物品放行
    return axios.post("Release/createRelease", data);
  },
  getReleaseRecord(data) {
    // 获取放行条记录列表
    return axios.post("Release/getReleaseRecord", data);
  },
  getReleaseRecordDetail(data) {
    // 获取放行条记录详细信息
    return axios.post("Release/getReleaseRecordDetail", data);
  },
  leaderAgreeRelease(data) {
    // 二级审批同意放行条申请
    return axios.post("Release/leaderAgreeRelease", data);
  },
  leaderRefuseRelease(data) {
    // 二级审批拒绝放行条申请
    return axios.post("Release/leaderRefuseRelease", data);
  },
  searchReleaseLeaderLst(data) {
    // 查找放行条审批人
    return axios.post("Release/searchReleaseLeaderLst", data);
  },

  getReleaseRecordToday(data) {
    // 查找放行条审批人
    return axios.post("Release/getReleaseRecordToday", data);
  },
  getReleaseRecordReturn(data) {
    //
    return axios.post("Release/getReleaseRecordReturn", data);
  },

  securityAgreeReturn(data) {
    // 保安确定物品返回
    return axios.post("Release/securityAgreeReturn", data);
  },

  getReleaseRecordLeader(data) {
    //
    return axios.post("Release/getReleaseRecordLeader", data);
  },

  getCorpLst(data) {
    // 获取企业列表
    return axios.post("wechat/getCorpLst", data);
  },

  uploadImages(data) {
    // 把微信公众号的临时照片存储到本地，并反馈照片是人脸是人脸照片是否符合初期的入库标准
    return axios.post("Server/uploadImages", data);
  },

  getmytype(data) {
    return axios.post("Server/getmytype", data);
  },

  getVisitorFollow(data) {
    //
    return axios.post("Visitor/getVisitorFollow", data);
  },

  getVisitorCarFollow(data) {
    //
    return axios.post("Visitor/getVisitorCarFollow", data);
  },

  addVisitorFollow(data) {
    //
    return axios.post("Visitor/addVisitorFollow", data);
  },

  addVisitorCarFollow(data) {
    //
    return axios.post("Visitor/addVisitorCarFollow", data);
  },
  deleteVisitorFollow(data) {
    //
    return axios.post("Visitor/deleteVisitorFollow", data);
  },

  getVisitorStaffFollow(data) {
    //
    return axios.post("Visitor/getVisitorStaffFollow", data);
  },

  addVisitorStaffFollow(data) {
    //
    return axios.post("Visitor/addVisitorStaffFollow", data);
  },
  deleteVisitorStaffFollow(data) {
    //
    return axios.post("Visitor/deleteVisitorStaffFollow", data);
  },

  getTruckFollow(data) {
    //
    return axios.post("Truck/getTruckFollow", data);
  },

  addTruckFollow(data) {
    //
    return axios.post("Truck/addTruckFollow", data);
  },
  deleteTruckFollow(data) {
    //
    return axios.post("Truck/deleteTruckFollow", data);
  },

  getTruckStaffFollow(data) {
    //
    return axios.post("Truck/getTruckStaffFollow", data);
  },

  addTruckStaffFollow(data) {
    //
    return axios.post("Truck/addTruckStaffFollow", data);
  },
  deleteTruckStaffFollow(data) {
    //
    return axios.post("Truck/deleteTruckStaffFollow", data);
  },

  tpersonal(data) {
    //
    return axios.post("Truck/tpersonal", data);
  },
  getTruckInfo() {
    return axios.post("Truck/getTruckInfo");
  },

  treserve(data) {
    //发起预约
    return axios.post("Truck/treserve", data);
  },

  getTSRecord(data) {
    //被访人员获取模板消息的记录
    return axios.post("Staff/getTSRecord", data);
  },

  getTruckRecord(data) {
    // -当天
    return axios.post("Truck/getTruckRecord", data);
  },
  getTruckRecordToday(data) {
    // -当天
    return axios.post("Truck/getTruckRecordToday", data);
  },
  getTruckRecordDetailToday(data) {
    // -当天
    return axios.post("Truck/getTruckRecordDetailToday", data);
  },
  securityAgreeRelease(data) {
    // 保安确定放行放行条申请
    return axios.post("Release/securityAgreeRelease", data);
  },
  securityRefuseRelease(data) {
    // 保安拒绝放行
    return axios.post("Security/securityRefuseRelease", data);
  },

  securityAgreeTruck(data) {
    //
    return axios.post("Security/securityAgreeTruck", data);
  },
  securityRefuseTruck(data) {
    //
    return axios.post("Security/securityRefuseTruck", data);
  },
  staffAgreeReturn(data) {
    //
    return axios.post("Release/staffAgreeReturn", data);
  },

  getCorpTicket(data) {
    //获取企业微信Ticket
    return axios.post("Server/getCorpTicket", data);
  },

  truckStaffRefuse(data) {
    //被访人员拒绝来访
    return axios.post("Staff/truckStaffRefuse", data);
  },
  truckStaffAgree(data) {
    //被访人员同意来访
    return axios.post("Staff/truckStaffAgree", data);
  },
  truckLeaderRefuse(data) {
    //领导拒绝来访
    return axios.post("Staff/truckLeaderRefuse", data);
  },
  truckLeaderAgree(data) {
    //领导同意来访
    return axios.post("Staff/truckLeaderAgree", data);
  },

  getScores(data) {
    //获取分数
    return axios.post("Server/getScores", data);
  },
  getKaoShi(data) {
    //获取考试试题
    return axios.post("Server/getKaoShi", data);
  },
  submitdati(data) {
    //
    return axios.post("Server/submitdati", data);
  },
  getIdCardInfomation(data) {
    //
    return axios.post("Server/getIdCardInfomation", data);
  },
  getVisitorList(data) {
    //
    return axios.post("Visitor/getVisitorList", data);
  },

  getCarType() {
    // 获取车辆类型
    return axios.post("Server/getCarType");
  },
  getCarJtfs() {
    // 获取车辆交通方式
    return axios.post("Server/getCarJtfs");
  },
  getCarClxz() {
    // 获取车辆性质
    return axios.post("Server/getCarClxz");
  },

  getOrganizeList() {
    // 获取组织列表
    return axios.post("Server/getOrganizeList");
  },

  getNotice(data) {
    // 获取来访须知
    return axios.post("Server/getNotice", data);
  },

  getMainPhoto(data) {
    // 获取主图
    return axios.post("Server/getMainPhoto", data);
  },

  //整合获取拜访事由、获取拜访单位、获取访客类型、获取组织列表
  getServer(data) {
    return axios.post("Server/getServer", data);
  },

  // 退出员工登录
  logOut(data) {
    //
    return axios.post("Staff/logOut", data);
  },

  uploadExcel(data) {
    //上传批量邀请的exel表格名单
    return axios.post("Server/uploadExcel", data);
  }
};



// WEBPACK FOOTER //
// ./src/http.js